<app-popover (closeCallback)="cancelCallback()" size="send-invoice" titleText="Send Invoice" [scrollable]="true">
  <div popover-content>
    <form [formGroup]="formDetails" *ngIf="formDetails">
      <div class="field-wrapper">
        <label class="field-label">Select Recipient</label>
        <div class="options">
          <ng-container *ngFor="let recipient of recipientType">
            <ng-container *ngIf="checkVisibility(this.config[recipient.value].config)">
              <div class="option" *ngIf="recipient.value != 'transportManager'">
               <span class="checkCount">{{selectedItemLength}}</span>
                <app-dropdown-checkbox
                (selectedItemLength)="getItemLength($event)"
                [width]="'176px'"
                [dropdownListWidth]="'176px'"
                class="option-dropdown"
                [label]="recipient.dropdownLabel"
                [formControl]="formDetails.get(recipient.value)"
                [getCustomOptionValue]="getOptionValue"
                [getCustomOptionLabel]="getOptionLabel"
                [options]="getOptions(recipient.value)">
              </app-dropdown-checkbox>
              <!--   <app-multiselect class="option-dropdown" [width]="'176px'" [dropdownListWidth]="'176px'" [label]="recipient.dropdownLabel"
                  [formControl]="formDetails.get(recipient.value)" [getCustomOptionValue]="getOptionValue"
                  [getCustomOptionLabel]="getOptionLabel" [options]="getOptions(recipient.value)">
                </app-multiselect> -->
              </div>
              <div class="option" *ngIf="recipient.value == 'transportManager'">
                <app-radio-button class="option-radio" [option]="recipient"
                  [selectedValue]="formDetails.get('recipientType').value" name="recipientType"
                  (changeCallback)="onRecipientChange($event)">
                </app-radio-button>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <div class="field-wrapper message">
        <label class="field-label">Message</label>
        <app-text-input [multiline]="true" placeholder="Type subject" [formControl]="formDetails.get('comment')">
        </app-text-input>
        <span *ngIf="showError" class="errorField">This field is mandatory</span>
      </div>

    </form>
  </div>
  <div popover-actions class="send-invoice-actions">
    <app-button class="mr-10" (clickCallback)="cancelCallback()" type="plainText" text="Cancel"></app-button>
    <app-button type="primaryFilled" text="Send" (clickCallback)="onSubmitClick()"></app-button>
  </div>
</app-popover>